<template>
  <div
    class="editor-play-sprite"
    :style="{zIndex: sprite.index * 5 + 1}"
  >
    <div
      v-show="sprite.show"
      ref="spriteDom"
      class="play-sprite"
      :style="spriteStyle"
    ></div>
    <div
      v-if="enterHand"
      v-show="enterHand.show"
      ref="enterHandDom"
      class="sprite-enter-hand"
      :style="enterHandStyle"
    ></div>
    <div
      v-if="exitHand"
      v-show="exitHand.show"
      ref="exitHandDom"
      class="sprite-exit-hand"
      :style="exitHandStyle"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'EditorPlaySprite',
  props: {
    sprite: {
      type: Object,
      required: true,
    }
  },
  data(){
    return{
      enterHand: null,
      exitHand: null
    };
  },
  computed: {
    spriteStyle() {
      const style = {};
      style.top = `${this.sprite.top}px`;
      style.left = `${this.sprite.left}px`;
      style.width = `${this.sprite.width}px`;
      style.height = `${this.sprite.height}px`;
      style.opacity = `${this.sprite.opacity}`;
      style.backgroundColor = this.sprite.bgColor;
      style.transform = `rotate(${this.sprite.rotate}deg) scaleX(${this.sprite.flip ? -1: 1}) scale(${this.sprite.scale})`;
      style.boxShadow = this.sprite.boxShadow;
      return style;
    },
    enterHandStyle() {
      const style = {};
      style.top = `${this.enterHand.top}px`;
      style.left = `${this.enterHand.left}px`;
      return style;
    },
    exitHandStyle() {
      const style = {};
      style.top = `${this.exitHand.top}px`;
      style.left = `${this.exitHand.left}px`;
      return style;
    }
  },
  mounted() {
    this.$nextTick(async () => {
      let effect = this.sprite.effect;
      this.enterHand = effect.enterHand;
      this.exitHand = effect.exitHand;
      await this.sprite.initDom(this.$refs.spriteDom);
      if(this.enterHand && this.enterHand.img) {
        this.$refs.enterHandDom.appendChild(this.enterHand.img);
        this.$refs.enterHandDom.style.transformOrigin = `${this.enterHand.anchorPointX}px ${this.enterHand.anchorPointY}px`;
        this.$refs.enterHandDom.style.transform = `rotate(${this.enterHand.rotate}deg) scale(1.6)`;
      }
      if(this.exitHand && this.exitHand.img) {
        this.$refs.exitHandDom.appendChild(this.exitHand.img);
        this.$refs.exitHandDom.style.transformOrigin = `${this.exitHand.anchorPointX}px ${this.exitHand.anchorPointY}px`;
        this.$refs.exitHandDom.style.transform = `rotate(${this.exitHand.rotate}deg) scale(1.6)`;
      }
      this.sprite.effect.play(0);
      this.$emit('loadDone');
    });
  }
};
</script>
<style lang="scss" scoped>
.editor-play-sprite, .play-sprite, .sprite-enter-hand, .sprite-exit-hand {
  position: absolute;
  box-sizing: border-box;
}
.sprite-enter-hand, .sprite-exit-hand {
  z-index: 20;
}
</style>
<style>
.sprite-enter-hand img, .sprite-exit-hand img {
  max-width: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/editorPlaySprite.vue